<template>
    <v-app id="inspire" class="app">
        <app-drawer class="app--drawer" :appName="config.appName"></app-drawer>

        <transition name="slideDown" enter-active-class="slideInDown" leave-active-class="slideOutUp">
            <app-toolbar class="app--toolbar" v-show="initTBar" :config="config"></app-toolbar>
        </transition>

        <v-content>
            <transition name="slideUp" enter-active-class="slideInUp" leave-active-class="slideOutDown">
                <div class="page-wrapper" v-show="initContent">
                    <slot></slot>
                </div>
            </transition>
        </v-content>

        <!-- Go to top -->
        <app-fab></app-fab>

        <!-- chat button -->
        <v-btn v-if="config.chatButton"
               small fab dark falt fixed top right class="setting-fab" color="primary"
               @click="openChatWindow">
            <v-icon>far fa-comments</v-icon>
        </v-btn>

        <app-right-drawer></app-right-drawer>

    </v-app>
</template>

<script>
   import AppDrawer from './components/AppDrawer';
   import AppToolbar from './components/AppToolbar';
   import AppFab from './components/AppFab';
   import AppRightDrawer from './components/AppRightDrawer';

   import menu from '@/api/menu';

   export default {
      name: "admin-layout",

      props: {
         config: {
            type: Object,
            required: false
         }
      },

      components: {
         AppDrawer,
         AppRightDrawer,
         AppToolbar,
         AppFab
      },

      data() {
         return {
            initTBar: false,
            initContent: false,
            currentComponent: null
         }
      },

      methods: {
         openChatWindow() {
            // this.$vuetify.goTo(0);
            window.getApp.$emit('APP_RIGHT_DRAWER_TOGGLED');
         }

      },

      mounted() {
         setTimeout(() => this.initTBar = true, 100);
         setTimeout(() => this.initContent = true, 100);

         window.getApp.$on('APP_LOGOUT', () => {
            this.initContent = false;
            this.initTBar = false;
         })

         // this.$eBus.$on('showSearchDrawer', this.showSearch);

      }
   }
</script>


<style>

</style>


// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/layout/AdminLayout.vue